<button
  (click)="openMigrationPopup()"
  id="alert-border-4"
  class="w-full flex items-center p-4 text-kimbo-ruby border-t-4 border-kimbo-ruby bg-kimbo-ruby bg-opacity-10 relative cursor-pointer"
  role="alert">
  <div
    class="w-fit mx-auto ms-3 text-sm font-medium flex justify-center items-center gap-4">
    <div [inlineSVG]="'assets/svg/info.svg'"></div>
    <span>{{ 'kimbo-layout.migration-notice-heading' | translate }}</span>
  </div>
  <div class="flex items-center justify-center gap-2 underline">
    <mat-icon class="w-6">open_in_new</mat-icon>
  </div>
</button>
